module.exports = __webpack_public_path__ + "static/img/game_dialog_bg.8c4f188.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/game/game_dialog_bg.png
// module id = 8SBG
// module chunks = 28